import React, { useState } from "react";
import { IXactimateToolRowData } from "../../../../../shared/common/Azure";
import { XactimateBadge } from "./shared";
import { MappingCardEditor } from "./MappingCardEditor";

interface MappingCardProps {
    mapping: IXactimateToolRowData;
    children?: React.ReactNode;
    variant?: "good" | "bad";
    onUpdate?: (updated: IXactimateToolRowData) => Promise<void> | void;
    onDelete?: (id: string) => Promise<void> | void;
}

export const MappingCard = ({ mapping, children, variant = "good", onUpdate, onDelete }: MappingCardProps) => {
    const variantClasses = variant === "bad" ? "bg-red-50 border-red-200" : "bg-green-50 border-green-200";
    const editable = !!onUpdate || !!onDelete;
    const [isEditing, setIsEditing] = useState(false);

    return (
        <div className={`border rounded-lg p-3 ${variantClasses}`}>
            <p className="font-mono text-xs text-stone-700 mb-1">{mapping.acceptedLineString}</p>
            {children}
            {isEditing && onUpdate ? (
                <MappingCardEditor
                    mapping={mapping}
                    onSave={onUpdate}
                    onCancel={() => setIsEditing(false)}
                    onDelete={onDelete}
                />
            ) : (
                <div className="flex items-center gap-2 flex-wrap mt-1">
                    <XactimateBadge mapping={mapping} />
                    {editable && (
                        <button
                            className="text-xs text-stone-500 hover:text-stone-700 underline ml-auto"
                            onClick={() => setIsEditing(true)}
                        >
                            Edit
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
